"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelperFactory = void 0;
var common_helper_1 = require("./common-helper");
var wps_helper_1 = require("./wps-helper");
var HelperFactory = /** @class */ (function () {
    function HelperFactory() {
    }
    HelperFactory.createHelper = function () {
        // wps插件2.0内
        if (window.Extention) {
            return new wps_helper_1.WpsHelper();
        }
        return new common_helper_1.CommonHelper();
    };
    return HelperFactory;
}());
exports.HelperFactory = HelperFactory;
exports.default = HelperFactory.createHelper();
